const imoBlacklist = [
	// 0000000,
	// 1234567,
	// blacklisted IMO
];
// Pass true in second param to return an object with response and stage of failure
export default function (imo, verbose = false) {
	if (("" + imo).length !== 7) {
		return false;
	}
	const regex = new RegExp("^[0-9]{7}$");
	if (!regex.test(imo)) return verbose ? { response: false, stage: "num/len regex fail" } : false;
	const imoIsBlacklisted = imoBlacklist.findIndex(blacklisted => blacklisted === imo) > -1;
	if (imoIsBlacklisted) return verbose ? { response: false, stage: "imo blacklist fail" } : false;

	const chars = imo.split("");
	const sum =
		chars[0] * 7 +
		chars[1] * 6 +
		chars[2] * 5 +
		chars[3] * 4 +
		chars[4] * 3 +
		chars[5] * 2;
	const lastCharOfSum = sum.toString().slice(-1);
	const lastCharOfImo = imo.slice(-1);
	const checksumValid = lastCharOfSum === lastCharOfImo;

	if (!checksumValid) return verbose ? { response: false, stage: "checksum fail" } : false;
	return verbose ? [true] : true;
}
